export default function Footer() {
  const quickLinks = [
    { label: '热门剧集排行榜', href: '#ranking' },
    { label: '最新上架动态', href: '#updates' },
    { label: '剧集分类索引', href: '#index' },
    { label: '精选推荐', href: '#carousel' },
    { label: '追剧指南', href: '#cards' },
    { label: '剧迷热评', href: '#comments' },
  ];

  return (
    <footer id="footer" className="bg-background-50 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-movie-2-line text-background-50 text-lg"></i>
                </span>
                <span className="text-lg font-bold text-foreground-950 font-heading">红桃影视</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                红桃影视电视剧频道收录海量全集资源，热门剧集、最新大陆剧韩剧持续更新，高清画质免费在线观看，追剧不等待。每日更新热门剧集，覆盖大陆剧、韩剧、港剧等多种类型，为剧迷提供一站式追剧体验。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4 font-heading">快速导航</h4>
              <ul className="space-y-3">
                {quickLinks.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4 font-heading">剧集类型</h4>
              <ul className="space-y-3">
                <li><span className="text-sm text-foreground-600">大陆剧全集</span></li>
                <li><span className="text-sm text-foreground-600">最新韩剧</span></li>
                <li><span className="text-sm text-foreground-600">热门港剧</span></li>
                <li><span className="text-sm text-foreground-600">高分台剧</span></li>
                <li><span className="text-sm text-foreground-600">经典日剧</span></li>
                <li><span className="text-sm text-foreground-600">美剧精选</span></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4 font-heading">合作伙伴</h4>
              <p className="text-sm text-foreground-500 leading-relaxed">
                更多合作伙伴信息即将上线，敬请期待。
              </p>
              <div className="mt-6">
                <h4 className="text-sm font-semibold text-foreground-950 mb-3 font-heading">关注我们</h4>
                <div className="flex items-center gap-3">
                  <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 text-foreground-500 hover:text-primary-400 hover:bg-primary-100/30 transition-colors cursor-pointer">
                    <i className="ri-wechat-line text-lg"></i>
                  </span>
                  <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 text-foreground-500 hover:text-primary-400 hover:bg-primary-100/30 transition-colors cursor-pointer">
                    <i className="ri-weibo-line text-lg"></i>
                  </span>
                  <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 text-foreground-500 hover:text-primary-400 hover:bg-primary-100/30 transition-colors cursor-pointer">
                    <i className="ri-bilibili-line text-lg"></i>
                  </span>
                  <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 text-foreground-500 hover:text-primary-400 hover:bg-primary-100/30 transition-colors cursor-pointer">
                    <i className="ri-tiktok-line text-lg"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-10 md:mt-12 pt-6 border-t border-background-200/60">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
              <p className="text-xs text-foreground-500">
                &copy; {new Date().getFullYear()} 红桃影视 HongTao.TV - 高清剧集在线观看平台
              </p>
              <div className="flex items-center gap-4">
                <span className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">用户协议</span>
                <span className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">隐私政策</span>
                <span className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">版权声明</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}